import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router';
import { useAuthContext } from '../../contexts/AuthContext';

const Callback = () => {
    const navigate = useNavigate();
    const { setToken, setTenant, setUser, setZones, setTags } = useAuthContext();

    useEffect(() => {
        const handleAuth = async () => {
            try {
                const currentUser = await Auth.currentAuthenticatedUser();
                const idToken = currentUser.signInUserSession.idToken.jwtToken;
                const accessToken = currentUser.signInUserSession.accessToken.jwtToken;
                const refreshToken = currentUser.signInUserSession.refreshToken.token;

                // Você pode agora armazenar esses tokens no localStorage ou contexto
                localStorage.setItem('nova_videowall_idToken', idToken);
                localStorage.setItem('nova_videowall_accessToken', accessToken);
                setToken(accessToken);

                if(refreshToken) {
                    localStorage.setItem('nova_videowall_refreshToken', refreshToken);
                    localStorage.setItem('nova_videowall_loginType', 'cognito');
                } else {
                    localStorage.setItem('nova_videowall_loginType', 'AD');
                }

                const attributes = currentUser.attributes;
                setUser(currentUser.username);
                localStorage.setItem('nova_videowall_user', currentUser.username);
                const parsedTenant = attributes['custom:tenant'] ? JSON.parse(attributes['custom:tenant']) : null;
                setTenant(parsedTenant?.[0]);
                localStorage.setItem('nova_videowall_tenant', JSON.stringify(parsedTenant));
                const parsedZones = attributes['custom:zones'] ? JSON.parse(attributes['custom:zones']) : [];
                setZones(parsedZones);
                localStorage.setItem('nova_videowall_zones', attributes['custom:zones']);
                const parsedTags = attributes['custom:tags'] ? JSON.parse(attributes['custom:tags']) : [];
                setTags(parsedTags);
                localStorage.setItem('nova_videowall_tags', attributes['custom:tags']);

                // Redireciona para a página principal ou onde for necessário
                navigate('/map');
            } catch (error) {
                console.error('Erro ao autenticar usuário', error);
                navigate('/login');
            }
        };

        handleAuth();
    }, [navigate]);

    return <div>Autenticando...</div>;
};

export default Callback;